const VoucherCampaignGroup = {
  SPIAllowance: 'spi-allowance',
  SPIAllocation: 'spi-allocation',
  SPIOBTravel: 'spi-ob-travel',
  Others: 'others'
};

export default VoucherCampaignGroup;
